import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NavigatorState } from './navigator.reducer';

export const BS_XS = 'xs';

export const navigatorState = createFeatureSelector<NavigatorState>("navigator");

export const navigatorBsResChange = createSelector(
	navigatorState,
	state => { 
		return { prevBsRes: state.prevBsRes, actualBsRes: state.actualBsRes }
	}
);

export const navigatorActualBsRes = createSelector(
	navigatorState,
	state => state.actualBsRes
);

